var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"domRef",staticClass:"word-to-img",style:({backgroundColor: `${_vm.bgColor}`,width: `${_vm.wWidth}px`}),domProps:{"innerHTML":_vm._s(_vm.htmlStr)}})
}
var staticRenderFns = []

export { render, staticRenderFns }